/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * OrderAddressIssueCountsDtoBase
 * auto generated base class for the model OrderAddressIssueCountsDtoModel.
 *
 * How many orders in a filtered set have each kind of address issue. The two kinds are mutually
 * exclusive — an order with any invalid location counts as `invalid`, never `questionable` — so
 * `invalid + questionable` equals the number of orders `filter.addressIssues: true` returns.
 */
export const OrderAddressIssueCountsDtoModelBase = ModelBase
  .named('OrderAddressIssueCountsDto')
  .props({
    __typename: types.optional(types.literal("OrderAddressIssueCountsDto"), "OrderAddressIssueCountsDto"),
    /** Orders with at least one invalid (un-geocodable) location. */
    invalid: types.union(types.undefined, types.integer),
    /** Orders whose active location geocoded to something other than a best match, and which have no invalid location. */
    questionable: types.union(types.undefined, types.integer),
    /** Orders with an address issue of either kind. Always equals invalid + questionable. */
    total: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrderAddressIssueCountsDtoModelSelector extends QueryBuilder {
  get invalid() { return this.__attr(`invalid`) }
  get questionable() { return this.__attr(`questionable`) }
  get total() { return this.__attr(`total`) }
}
export function selectFromOrderAddressIssueCountsDto() {
  return new OrderAddressIssueCountsDtoModelSelector()
}

export const orderAddressIssueCountsDtoModelPrimitives = selectFromOrderAddressIssueCountsDto().invalid.questionable.total
